export class Plano {
    idPlano: number;
    nmPlano: string;
    nrPlanoSpc : string;
}